import React, { Component } from "react";
import Header from "../../../layout/Header";
import Sidebar from "../../../layout/Sidebar";
import { Spin, Tooltip } from "antd";
import Bridge from "../../../constants/Bridge";
import toggleFullscreen from "toggle-fullscreen";
import SectionHeader from "./common/SectionHeader";
// sections
import AlsPsychosisSection from "./components/view/AlsPsychosisSection";
import BehaviorSection from "./components/view/BehaviorSection";
import MemoryDelayedRec from "./components/view/MemoryDelayedRec";
import MemoryDelayedRecall from "./components/view/MemoryDelayedRecall";
import SocialCongPartA from "./components/view/SocialCongPartA";
import SocialCongPartB from "./components/view/SocialCongPartB";
import SentenceCompletion from "./components/view/SentenceCompletion";
import NumberLocation from "./components/view/NumberLocation";
import CubeCountingSection from "./components/view/CubeCountingSection";
import DotCountingSection from "./components/view/DotCountingSection";
import FluencyLetterT from "./components/view/FluencyLetterT";
import FluencyLetterS from "./components/view/FluencyLetterS";
import LanguageSpellingSection from "./components/view/LanguageSpellingSection";
import LanguageNamingSection from "./components/view/LanguageNamingSection";
import ImmediateRecall from "./components/view/ImmediateRecall";
import ReverseDigitSpan from "./components/view/ReverseDigitSpan";
import AlternationSection from "./components/view/AlternationSection";
import LanguageComprehension from "./components/view/LanguageComprehension";

class View extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      loading: false,
      participantList: [],
      cparticipantList: [],
      searchedData: [],
      checkbox: false,
      selectedEmail: "",
      selectedModalityId: "",
      selectedNeurostampId: "",
      age: "",
      name: "",
      occupation: "",
      handedness: "",
      date_of_birth: "",
      hospital_no_or_address: "",
      picture_name_1: "",
      picture_name_2: "",
      picture_name_3: "",
      picture_name_4: "",
      picture_name_5: "",
      picture_name_6: "",
      picture_name_7: "",
      picture_name_8: "",
      picture_status_1: false,
      picture_status_2: false,
      picture_status_3: false,
      picture_status_4: false,
      picture_status_5: false,
      picture_status_6: false,
      picture_status_7: false,
      picture_status_8: false,

      written_picture_score: 0,
      comprehension_question_1: "",
      comprehension_question_2: "",
      comprehension_question_3: "",
      comprehension_question_4: "",
      comprehension_question_5: "",
      comprehension_question_6: "",
      comprehension_question_7: "",
      comprehension_question_8: "",
      recall_score: 0,
      spelling_score: 0,
      spelling_envelop_text: "",
      spelling_skate_board_text: "",
      spelling_constructing_text: "",
      spelling_partner_text: "",
      spelling_biscuit_text: "",
      spelling_lawnmower_text: "",
      spelling_deliver_text: "",
      spelling_coarhanger_text: "",
      spelling_screwdriver_text: "",
      spelling_lowenmover_text: "",
      spelling_recorded_text: "",
      spelling_orchestra_text: "",
      spelling_brought_text: "",
      spelling_envelop_text_status: false,
      spelling_skate_board_text_status: false,
      spelling_constructing_text_status: false,
      spelling_partner_text_status: false,
      spelling_biscuit_text_status: false,
      spelling_lawnmower_text_status: false,
      spelling_deliver_text_status: false,
      spelling_coarhanger_text_status: false,
      spelling_screwdriver_text_status: false,
      spelling_lowenmover_text_status: false,
      spelling_recorded_text_status: false,
      spelling_orchestra_text_status: false,
      spelling_brought_text_status: false,
      fluency_ls_no_of_correct_words: "",
      fluency_ls_time_to_copy: "",
      fluency_ls_score: 0,
      reverse_digit_span_score: 0,
      sentence_completion_score: 0,

      reverse_digit_span_trial1: false,
      reverse_digit_span_trial2: false,
      reverse_digit_span_trial3: false,
      reverse_digit_span_trial4: false,
      reverse_digit_span_trial5: false,
      reverse_digit_span_trial6: false,
      reverse_digit_span_trial7: false,
      reverse_digit_span_trial8: false,
      reverse_digit_span_trial9: false,
      reverse_digit_span_trial10: false,
      reverse_digit_span_trial11: false,
      reverse_digit_span_trial12: false,

      executive_alternation_score: 0,

      executive_alternation_trial1: false,
      executive_alternation_trial2: false,
      executive_alternation_trial3: false,
      executive_alternation_trial4: false,
      executive_alternation_trial5: false,
      executive_alternation_trial6: false,
      executive_alternation_trial7: false,
      executive_alternation_trial8: false,
      executive_alternation_trial9: false,
      executive_alternation_trial10: false,
      executive_alternation_trial11: false,
      executive_alternation_trial12: false,

      fluency_lt_no_of_correct_words: 0,
      fluency_lt_time_to_copy: 0,
      fluency_lt_score: 0,
      dot_countring_score: 0,

      dot_status_1: false,
      dot_status_2: false,
      dot_status_3: false,
      dot_status_4: false,

      cube_countring_score: 0,

      cube_status_1: false,
      cube_status_2: false,
      cube_status_3: false,
      cube_status_4: false,

      number_location_score: 0,

      number_location_status_1: false,
      number_location_status_2: false,
      number_location_status_3: false,
      number_location_status_4: false,

      sentence_completion_q1_s1: "",
      sentence_completion_q1_s2: "",
      sentence_completion_q2_s1: "",
      sentence_completion_q2_s2: "",
      sentence_completion_q2_s3: "",
      sentence_completion_q2_s4: "",
      sentence_completion_q2_s5: "",
      sentence_completion_q2_s6: "",
      social_congnition_score: 0,

      social_congnition_statuspa1: false,
      social_congnition_statuspa2: false,
      social_congnition_statuspa3: false,
      social_congnition_statuspa4: false,
      social_congnition_statuspa5: false,
      social_congnition_statuspa6: false,
      social_congnition_statuspb1: false,
      social_congnition_statuspb2: false,
      social_congnition_statuspb3: false,
      social_congnition_statuspb4: false,
      social_congnition_statuspb5: false,
      social_congnition_statuspb6: false,
      social_congnition_statuspb_error_1: false,
      social_congnition_statuspb_error_2: false,
      social_congnition_statuspb_error_3: false,
      social_congnition_statuspb_error_4: false,
      social_congnition_statuspb_error_5: false,
      social_congnition_statuspb_error_6: false,
      social_congnition_b_selected_image_1: "",
      social_congnition_b_selected_image_2: "",
      social_congnition_b_selected_image_3: "",
      social_congnition_b_selected_image_4: "",
      social_congnition_b_selected_image_5: "",
      social_congnition_b_selected_image_6: "",

      delayed_recall_value: 0,

      delayed_re_question_1_status: false,
      delayed_re_question_2_status: false,
      delayed_re_question_3_status: false,
      delayed_re_question_4_status: false,
      delayed_re_question_5_status: false,
      delayed_re_question_6_status: false,
      delayed_re_question_7_status: false,
      delayed_re_question_8_status: false,
      delayed_re_question_1_status_description: "",
      delayed_re_question_2_status_description: "",
      delayed_re_question_3_status_description: "",
      delayed_re_question_4_status_description: "",
      delayed_re_question_5_status_description: "",
      delayed_re_question_6_status_description: "",
      delayed_re_question_7_status_description: "",
      delayed_re_question_8_status_description: "",

      delayed_recall_score: 0,
      delayed_congniation_total_score: 0,
      immediate_recall_score: 0,
      retained_percentage_value: "",
      memory_d_r_score: 0,
      memory_d_r_score_checked_value: "",
      total_language_score: 0,
      total_verbal_fluency_score: 0,
      total_executive_score: 0,
      total_memory_score: 0,
      total_visuspatial_score: 0,
      ecas_total_score: 0,
      total_behavior_marks: 0,
      behavior_q1_status: "",
      behavior_q1_description: "",
      behavior_q2_status: "",
      behavior_q2_description: "",
      behavior_q3_status: "",
      behavior_q3_description: "",
      behavior_q4_status: "",
      behavior_q4_description: "",
      behavior_q5_status: "",
      behavior_q5_description: "",
      behavior_q6_status: "",
      behavior_q6_description: "",
      behavior_q7_status: "",
      behavior_q7_description: "",
      behavior_q8_status: "",
      behavior_q8_description: "",
      behavior_q9_status: "",
      behavior_q9_description: "",
      behavior_q10_status: "",
      behavior_q10_description: "",
      behaviour_symptom_status: false,
      apathy_symptom_status: false,
      loss_sympathy_symptom_status: false,
      perseverative_symptom_status: false,
      hyperorality_symptom_status: false,
      als_psychosis_q1_status: "",
      als_psychosis_q1_description: "",
      als_psychosis_q2_status: "",
      als_psychosis_q2_description: "",
      als_psychosis_q3_status: "",
      als_psychosis_q3_description: "",
      als_psychosis_score: 0,
      onset_duration_symtom_q1_status: "",
      onset_duration_symtom_q2_status: "",
      onset_duration_symtom_q3_status: "",
      onset_duration_symtom_q4_status: "",
      onset_duration_symtom_q5_status: "",
      letter_s_no_of_words: 0,
      letter_s_time_to_read: 0,
      letter_s_fluency_type: "speak",
      letter_t_fluency_type: "speak",
      delayed_retained_value: 0,
      ecas_form_id: 0,
      ecas_form_data: {},
      loading: false,
      immediaterRecallNote: "",
      sentence_completion_c1: "",
      sentence_completion_c2: "",
      sentence_completion_c3: "",
      sentence_completion_c4: "",
      sentence_completion_c5: "",
      sentence_completion_c6: "",
      delayed_recall_check_1: "",
      delayed_recall_check_2: "",
      delayed_recall_check_3: "",
      delayed_recall_check_4: "",
      delayed_recall_check_5: "",
      delayed_recall_check_6: "",
      delayed_recall_check_7: "",
      delayed_recall_check_8: "",
      delayed_recall_check_9: "",
      delayed_recall_check_10: "",

      social_congnition_b1_score: "",
      social_congnition_b2_score: "",
      social_congnition_b3_score: "",
      social_congnition_b4_score: "",
      social_congnition_b5_score: "",
      social_congnition_b6_score: "",

      social_congnition_a1_faverite_object: false,
      social_congnition_a2_faverite_object: false,
      social_congnition_a3_faverite_object: false,
      social_congnition_a4_faverite_object: false,
      social_congnition_a5_faverite_object: false,
      social_congnition_a6_faverite_object: false,
      noOfWords1: [],
      noOfWords: [],
      highest_completed_degree: "",
      language_dificulties: "",
      emailSearchText: "",
      fluecy_letter_s_stop_watch_1: 0,
      fluecy_letter_s_stop_watch_2: 0,
      fluecy_letter_t_stop_watch_1: 0,
      fluecy_letter_t_stop_watch_2: 0,
      immediate_recall_check_1_points: 0,
      immediate_recall_check_2_points: 0,
      immediate_recall_check_3_points: 0,
      immediate_recall_check_4_points: 0,
      immediate_recall_check_5_points: 0,
      immediate_recall_check_6_points: 0,
      immediate_recall_check_7_points: 0,
      immediate_recall_check_8_points: 0,
      immediate_recall_check_9_points: 0,
      immediate_recall_check_10_points: 0,
      caregiver: "0",
      percentageMeomeryCall: 0,
      responseData: "",
      isLoaded: false,
    };
  }
  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.search);
    const paramValue = searchParams.get("ID");
    if (paramValue) {
      this.setState({ ecas_form_id: paramValue }, () =>
        this.getEcasFormDetails(paramValue)
      );
    } else {
      window.location.assign("/ecas/list");
      return;
    }
  }

  getEcasFormDetails = (ecas_form_id) => {
    this.setState({ loading: true });
    let url = `?ecas_forms_id=${ecas_form_id}`;
    Bridge.ecas
      .get_details_by_id(url)
      .then((response) => {
        if (response.data.status == "1") {
          let sumitedate = response.data.data[0].submitted_date.split(",")[0];

          let recall_score1 = response.data.data[0].recall_score;
          let delayed_recall_value1 =
            response.data.data[0].delayed_recall_value;
          if (delayed_recall_value1 && recall_score1) {
            let perce =
              parseFloat(delayed_recall_value1) / parseFloat(recall_score1);
            this.setState({
              percentageMeomeryCall: parseFloat(perce * 100).toFixed(2),
            });
          }
          this.setState(
            {
              // basic details
              responseData: response.data.data[0],
              name: response.data.data[0].name,
              occupation: response.data.data[0].occupation,
              submitted_date: sumitedate,
              date_of_birth: response.data.data[0].date_of_birth,
              handedness: response.data.data[0].handedness,
              highest_completed_degree: response.data.data[0]
                .highest_completed_degree
                ? response.data.data[0].highest_completed_degree
                : "",
              language_dificulties: response.data.data[0].language_dificulties
                ? response.data.data[0].language_dificulties
                : "",
              age: response.data.data[0].age,
              emailSearchText: response.data.data[0].participant_email,
              modality_id: response.data.data[0].modality_id,
              neurostamp_id: response.data.data[0].neurostamp_id,
              caregiver: response.data.data[0].caregiver,

              // language naming
              picture_name_1: response.data.data[0].picture_name_1,
              picture_name_2: response.data.data[0].picture_name_2,
              picture_name_3: response.data.data[0].picture_name_3,
              picture_name_4: response.data.data[0].picture_name_4,
              picture_name_5: response.data.data[0].picture_name_5,
              picture_name_6: response.data.data[0].picture_name_6,
              picture_name_7: response.data.data[0].picture_name_7,
              picture_name_8: response.data.data[0].picture_name_8,
              picture_status_1: response.data.data[0].picture_status_1,
              picture_status_2: response.data.data[0].picture_status_2,
              picture_status_3: response.data.data[0].picture_status_3,
              picture_status_4: response.data.data[0].picture_status_4,
              picture_status_5: response.data.data[0].picture_status_5,
              picture_status_6: response.data.data[0].picture_status_6,
              picture_status_7: response.data.data[0].picture_status_7,
              picture_status_8: response.data.data[0].picture_status_8,
              written_picture_score:
                response.data.data[0].written_picture_score,

              //LANGUAGE - Comprehension
              comprehension_question_checkbox_1:
                response.data.data[0].comprehension_question_checkbox_1,
              comprehension_question_checkbox_2:
                response.data.data[0].comprehension_question_checkbox_2,
              comprehension_question_checkbox_3:
                response.data.data[0].comprehension_question_checkbox_3,
              comprehension_question_checkbox_4:
                response.data.data[0].comprehension_question_checkbox_4,
              comprehension_question_checkbox_5:
                response.data.data[0].comprehension_question_checkbox_5,
              comprehension_question_checkbox_6:
                response.data.data[0].comprehension_question_checkbox_6,
              comprehension_question_checkbox_7:
                response.data.data[0].comprehension_question_checkbox_7,
              comprehension_question_checkbox_8:
                response.data.data[0].comprehension_question_checkbox_8,
              comprehension_question_1:
                response.data.data[0].comprehension_question_1,
              comprehension_question_2:
                response.data.data[0].comprehension_question_2,
              comprehension_question_3:
                response.data.data[0].comprehension_question_3,
              comprehension_question_4:
                response.data.data[0].comprehension_question_4,
              comprehension_question_5:
                response.data.data[0].comprehension_question_5,
              comprehension_question_6:
                response.data.data[0].comprehension_question_6,
              comprehension_question_7:
                response.data.data[0].comprehension_question_7,
              comprehension_question_8:
                response.data.data[0].comprehension_question_8,
              language_comprehension_score:
                response.data.data[0].language_comprehension_score,

              // immediate recall
              immediate_recall_check_1_points:
                response.data.data[0].immediate_recall_check_1_points,
              immediate_recall_check_2_points:
                response.data.data[0].immediate_recall_check_2_points,
              immediate_recall_check_3_points:
                response.data.data[0].immediate_recall_check_3_points,
              immediate_recall_check_4_points:
                response.data.data[0].immediate_recall_check_4_points,
              immediate_recall_check_5_points:
                response.data.data[0].immediate_recall_check_5_points,
              immediate_recall_check_6_points:
                response.data.data[0].immediate_recall_check_6_points,
              immediate_recall_check_7_points:
                response.data.data[0].immediate_recall_check_7_points,
              immediate_recall_check_8_points:
                response.data.data[0].immediate_recall_check_8_points,
              immediate_recall_check_9_points:
                response.data.data[0].immediate_recall_check_9_points,
              immediate_recall_check_10_points:
                response.data.data[0].immediate_recall_check_10_points,
              immediaterRecallNote: response.data.data[0].immediaterRecallNote,
              recall_score: response.data.data[0].recall_score,

              //LANGUAGE - Spelling
              spelling_biscuit_text:
                response.data.data[0].spelling_biscuit_text,
              spelling_biscuit_text_status:
                response.data.data[0].spelling_biscuit_text_status,
              spelling_brought_text:
                response.data.data[0].spelling_brought_text,
              spelling_brought_text_status:
                response.data.data[0].spelling_brought_text_status,
              spelling_coarhanger_text:
                response.data.data[0].spelling_coathanger_text,
              spelling_coarhanger_text_status:
                response.data.data[0].spelling_coathanger_text_status,
              spelling_constructing_text:
                response.data.data[0].spelling_constructing_text,
              spelling_constructing_text_status:
                response.data.data[0].spelling_constructing_text_status,
              spelling_deliver_text:
                response.data.data[0].spelling_deliver_text,
              spelling_deliver_text_status:
                response.data.data[0].spelling_deliver_text_status,
              spelling_envelop_text:
                response.data.data[0].spelling_envelop_text,
              spelling_envelop_text_status:
                response.data.data[0].spelling_envelop_text_status,
              spelling_lawnmower_text:
                response.data.data[0].spelling_lawnmower_text,
              spelling_lawnmower_text_status:
                response.data.data[0].spelling_lawnmower_text_status,
              spelling_lowenmover_text:
                response.data.data[0].spelling_lowenmover_text,
              spelling_lowenmover_text_status:
                response.data.data[0].spelling_lowenmover_text_status,
              spelling_orchestra_text:
                response.data.data[0].spelling_orchestra_text,
              spelling_orchestra_text_status:
                response.data.data[0].spelling_orchestra_text_status,
              spelling_partner_text:
                response.data.data[0].spelling_partner_text,
              spelling_partner_text_status:
                response.data.data[0].spelling_partner_text_status,
              spelling_recorded_text:
                response.data.data[0].spelling_recorded_text,
              spelling_recorded_text_status:
                response.data.data[0].spelling_recorded_text_status,
              spelling_score: response.data.data[0].spelling_score,
              spelling_screwdriver_text:
                response.data.data[0].spelling_screwdriver_text,
              spelling_screwdriver_text_status:
                response.data.data[0].spelling_screwdriver_text_status,
              spelling_skate_board_text:
                response.data.data[0].spelling_skate_board_text,
              spelling_skate_board_text_status:
                response.data.data[0].spelling_skate_board_text_status,

              // FLUENCY - Letter S
              noOfWords: response.data.data[0].fluency_letter_s_words
                ? JSON.parse(response.data.data[0].fluency_letter_s_words)
                : [],
              noOfWords1: response.data.data[0].fluency_letter_t_words
                ? JSON.parse(response.data.data[0].fluency_letter_t_words)
                : [],
              flu_s_part_1_note: response.data.data[0].flu_s_part_1_note,
              flu_s_part_2_note: response.data.data[0].flu_s_part_2_note,
              flu_t_part_1_note: response.data.data[0].flu_t_part_1_note,

              fluecy_letter_s_stop_watch_1: response.data.data[0]
                .fluecy_letter_s_stop_watch_1
                ? Number(response.data.data[0].fluecy_letter_s_stop_watch_1)
                : 0,
              fluecy_letter_s_stop_watch_2: response.data.data[0]
                .fluecy_letter_s_stop_watch_2
                ? Number(response.data.data[0].fluecy_letter_s_stop_watch_2)
                : 0,

              fluecy_letter_t_stop_watch_1: response.data.data[0]
                .fluecy_letter_t_stop_watch_1
                ? Number(response.data.data[0].fluecy_letter_t_stop_watch_1)
                : 0,
              fluecy_letter_t_stop_watch_2: response.data.data[0]
                .fluecy_letter_t_stop_watch_2
                ? Number(response.data.data[0].fluecy_letter_t_stop_watch_2)
                : 0,

              letter_s_no_of_words: response.data.data[0].letter_s_no_of_words,
              fluency_ls_score: response.data.data[0].fluency_ls_score,

              // reverse digit span
              reverse_digit_span_score:
                response.data.data[0].reverse_digit_span_score,
              reverse_digit_span_trial1:
                response.data.data[0].reverse_digit_span_trial1,
              reverse_digit_span_trial2:
                response.data.data[0].reverse_digit_span_trial2,
              reverse_digit_span_trial3:
                response.data.data[0].reverse_digit_span_trial3,
              reverse_digit_span_trial4:
                response.data.data[0].reverse_digit_span_trial4,
              reverse_digit_span_trial5:
                response.data.data[0].reverse_digit_span_trial5,
              reverse_digit_span_trial6:
                response.data.data[0].reverse_digit_span_trial6,
              reverse_digit_span_trial7:
                response.data.data[0].reverse_digit_span_trial7,
              reverse_digit_span_trial8:
                response.data.data[0].reverse_digit_span_trial8,
              reverse_digit_span_trial9:
                response.data.data[0].reverse_digit_span_trial9,
              reverse_digit_span_trial10:
                response.data.data[0].reverse_digit_span_trial10,
              reverse_digit_span_trial11:
                response.data.data[0].reverse_digit_span_trial11,
              reverse_digit_span_trial12:
                response.data.data[0].reverse_digit_span_trial12 == null ||
                response.data.data[0].reverse_digit_span_trial12 == "0"
                  ? 0
                  : 1,

              // excecutive alternation
              executive_alternation_score:
                response.data.data[0].executive_alternation_score,
              executive_alternation_trial1:
                response.data.data[0].executive_alternation_trial1 == 1
                  ? true
                  : false,
              executive_alternation_trial2:
                response.data.data[0].executive_alternation_trial2 == 1
                  ? true
                  : false,
              executive_alternation_trial3:
                response.data.data[0].executive_alternation_trial3 == 1
                  ? true
                  : false,
              executive_alternation_trial4:
                response.data.data[0].executive_alternation_trial4 == 1
                  ? true
                  : false,
              executive_alternation_trial5:
                response.data.data[0].executive_alternation_trial5 == 1
                  ? true
                  : false,
              executive_alternation_trial6:
                response.data.data[0].executive_alternation_trial6 == 1
                  ? true
                  : false,
              executive_alternation_trial7:
                response.data.data[0].executive_alternation_trial7 == 1
                  ? true
                  : false,
              executive_alternation_trial8:
                response.data.data[0].executive_alternation_trial8 == 1
                  ? true
                  : false,
              executive_alternation_trial9:
                response.data.data[0].executive_alternation_trial9 == 1
                  ? true
                  : false,
              executive_alternation_trial10:
                response.data.data[0].executive_alternation_trial10 == 1
                  ? true
                  : false,
              executive_alternation_trial11:
                response.data.data[0].executive_alternation_trial11 == 1
                  ? true
                  : false,
              executive_alternation_trial12:
                response.data.data[0].executive_alternation_trial12 == 1
                  ? true
                  : false,

              // FLUENCY - Letter T
              fluency_lt_score: response.data.data[0].fluency_lt_score,
              fluency_lt_no_of_correct_words:
                response.data.data[0].fluency_lt_no_of_correct_words,

              dot_countring_score: response.data.data[0].dot_countring_score,
              dot_status_1: response.data.data[0].dot_status_1,
              dot_status_2: response.data.data[0].dot_status_2,
              dot_status_3: response.data.data[0].dot_status_3,
              dot_status_4: response.data.data[0].dot_status_4,
              // cube couting
              cube_countring_score: response.data.data[0].cube_countring_score,
              cube_status_1: response.data.data[0].cube_status_1,
              cube_status_2: response.data.data[0].cube_status_2,
              cube_status_3: response.data.data[0].cube_status_3,
              cube_status_4: response.data.data[0].cube_status_4,
              // NUMBER LOCATION
              number_location_score:
                response.data.data[0].number_location_score,
              number_location_status_1:
                response.data.data[0].number_location_status_1,
              number_location_status_2:
                response.data.data[0].number_location_status_2,
              number_location_status_3:
                response.data.data[0].number_location_status_3,
              number_location_status_4:
                response.data.data[0].number_location_status_4,
              // SENTENCE COMPLETION
              sentence_completion_q1_s1:
                response.data.data[0].sentence_completion_q1_s1,
              sentence_completion_q1_s2:
                response.data.data[0].sentence_completion_q1_s2,
              sentence_completion_q2_s1:
                response.data.data[0].sentence_completion_q2_s1,
              sentence_completion_q2_s2:
                response.data.data[0].sentence_completion_q2_s2,
              sentence_completion_q2_s3:
                response.data.data[0].sentence_completion_q2_s3,
              sentence_completion_q2_s4:
                response.data.data[0].sentence_completion_q2_s4,
              sentence_completion_q2_s5:
                response.data.data[0].sentence_completion_q2_s5,
              sentence_completion_q2_s6:
                response.data.data[0].sentence_completion_q2_s6,
              sentence_completion_c1:
                response.data.data[0].sentence_completion_c1,
              sentence_completion_c2:
                response.data.data[0].sentence_completion_c2,
              sentence_completion_c3:
                response.data.data[0].sentence_completion_c3,
              sentence_completion_c4:
                response.data.data[0].sentence_completion_c4,
              sentence_completion_c5:
                response.data.data[0].sentence_completion_c5,
              sentence_completion_c6:
                response.data.data[0].sentence_completion_c6,
              sentence_completion_score:
                response.data.data[0].sentence_completion_score,

              // SOCIAL COGNITION
              social_congnition_statuspa1:
                response.data.data[0].social_congnition_statuspa1,
              social_congnition_statuspa2:
                response.data.data[0].social_congnition_statuspa2,
              social_congnition_statuspa3:
                response.data.data[0].social_congnition_statuspa3,
              social_congnition_statuspa4:
                response.data.data[0].social_congnition_statuspa4,
              social_congnition_statuspa5:
                response.data.data[0].social_congnition_statuspa5,
              social_congnition_statuspa6:
                response.data.data[0].social_congnition_statuspa6,
              social_congnition_b_selected_image_1:
                response.data.data[0].social_congnition_b_selected_image_1,
              social_congnition_b_selected_image_2:
                response.data.data[0].social_congnition_b_selected_image_2,
              social_congnition_b_selected_image_3:
                response.data.data[0].social_congnition_b_selected_image_3,
              social_congnition_b_selected_image_4:
                response.data.data[0].social_congnition_b_selected_image_4,
              social_congnition_b_selected_image_5:
                response.data.data[0].social_congnition_b_selected_image_5,
              social_congnition_b_selected_image_6:
                response.data.data[0].social_congnition_b_selected_image_6,

              social_congnition_b1_score:
                response.data.data[0].social_congnition_b1_score,
              social_congnition_b2_score:
                response.data.data[0].social_congnition_b2_score,
              social_congnition_b3_score:
                response.data.data[0].social_congnition_b3_score,
              social_congnition_b4_score:
                response.data.data[0].social_congnition_b4_score,
              social_congnition_b5_score:
                response.data.data[0].social_congnition_b5_score,
              social_congnition_b6_score:
                response.data.data[0].social_congnition_b6_score,
              social_congnition_score:
                response.data.data[0].social_congnition_score,
              // DELAY RECALL
              delayed_recall_value: response.data.data[0].delayed_recall_value,
              delayed_recall_score: response.data.data[0].delayed_recall_score,
              delayed_congniation_total_score:
                response.data.data[0].delayed_congniation_total_score,
              delayed_re_question_1_status:
                response.data.data[0].delayed_re_question_1_status,
              delayed_re_question_1_status_description:
                response.data.data[0].delayed_re_question_1_status_description,
              delayed_re_question_2_status:
                response.data.data[0].delayed_re_question_2_status,
              delayed_re_question_2_status_description:
                response.data.data[0].delayed_re_question_2_status_description,
              delayed_re_question_3_status:
                response.data.data[0].delayed_re_question_3_status,
              delayed_re_question_3_status_description:
                response.data.data[0].delayed_re_question_3_status_description,
              delayed_re_question_4_status:
                response.data.data[0].delayed_re_question_4_status,
              delayed_re_question_4_status_description:
                response.data.data[0].delayed_re_question_4_status_description,
              delayed_re_question_5_status:
                response.data.data[0].delayed_re_question_5_status,
              delayed_re_question_5_status_description:
                response.data.data[0].delayed_re_question_5_status_description,
              delayed_re_question_6_status:
                response.data.data[0].delayed_re_question_6_status,
              delayed_re_question_6_status_description:
                response.data.data[0].delayed_re_question_6_status_description,
              delayed_re_question_7_status:
                response.data.data[0].delayed_re_question_7_status,
              delayed_re_question_7_status_description:
                response.data.data[0].delayed_re_question_7_status_description,
              delayed_re_question_8_status:
                response.data.data[0].delayed_re_question_8_status,
              delayed_re_question_8_status_description:
                response.data.data[0].delayed_re_question_8_status_description,

              // BAHAVIOUR SCREEN
              behavior_q1_description:
                response.data.data[0].behavior_q1_description,
              behavior_q1_status: response.data.data[0].behavior_q1_status,
              behavior_q2_description:
                response.data.data[0].behavior_q2_description,
              behavior_q2_status: response.data.data[0].behavior_q2_status,
              behavior_q3_description:
                response.data.data[0].behavior_q3_description,
              behavior_q3_status: response.data.data[0].behavior_q3_status,
              behavior_q4_description:
                response.data.data[0].behavior_q4_description,
              behavior_q4_status: response.data.data[0].behavior_q4_status,
              behavior_q5_description:
                response.data.data[0].behavior_q5_description,
              behavior_q5_status: response.data.data[0].behavior_q5_status,
              behavior_q6_description:
                response.data.data[0].behavior_q6_description,
              behavior_q6_status: response.data.data[0].behavior_q6_status,
              behavior_q7_description:
                response.data.data[0].behavior_q7_description,
              behavior_q7_status: response.data.data[0].behavior_q7_status,
              behavior_q8_description:
                response.data.data[0].behavior_q8_description,
              behavior_q8_status: response.data.data[0].behavior_q8_status,
              behavior_q9_description:
                response.data.data[0].behavior_q9_description,
              behavior_q9_status: response.data.data[0].behavior_q9_status,
              behavior_q10_description:
                response.data.data[0].behavior_q10_description,
              behavior_q10_status: response.data.data[0].behavior_q10_status,

              total_behavior_marks: response.data.data[0].total_behavior_marks,
              // symtoms
              behaviour_symptom_status:
                response.data.data[0].behaviour_symptom_status,
              hyperorality_symptom_status:
                response.data.data[0].hyperorality_symptom_status,
              apathy_symptom_status:
                response.data.data[0].apathy_symptom_status,
              loss_sympathy_symptom_status:
                response.data.data[0].loss_sympathy_symptom_status,
              perseverative_symptom_status:
                response.data.data[0].perseverative_symptom_status,
              // als screen
              als_psychosis_q1_description:
                response.data.data[0].als_psychosis_q1_description,
              als_psychosis_q1_status:
                response.data.data[0].als_psychosis_q1_status,
              als_psychosis_q2_description:
                response.data.data[0].als_psychosis_q2_description,
              als_psychosis_q2_status:
                response.data.data[0].als_psychosis_q2_status,
              als_psychosis_q3_description:
                response.data.data[0].als_psychosis_q3_description,
              als_psychosis_q3_status:
                response.data.data[0].als_psychosis_q3_status,
              als_psychosis_score: response.data.data[0].als_psychosis_score,

              delayed_retained_value:
                response.data.data[0].delayed_retained_value,
              // onset and duration
              onset_duration_symtom_q1_status:
                response.data.data[0].onset_duration_symtom_q1_status,
              onset_duration_symtom_q2_status:
                response.data.data[0].onset_duration_symtom_q2_status,
              onset_duration_symtom_q3_status:
                response.data.data[0].onset_duration_symtom_q3_status,
              onset_duration_symtom_q4_status:
                response.data.data[0].onset_duration_symtom_q4_status,
              onset_duration_symtom_q5_status:
                response.data.data[0].onset_duration_symtom_q5_status,

              delayed_recall_check_1:
                response.data.data[0].delayed_recall_check_1,
              delayed_recall_check_2:
                response.data.data[0].delayed_recall_check_2,
              delayed_recall_check_3:
                response.data.data[0].delayed_recall_check_3,
              delayed_recall_check_4:
                response.data.data[0].delayed_recall_check_4,
              delayed_recall_check_5:
                response.data.data[0].delayed_recall_check_5,
              delayed_recall_check_6:
                response.data.data[0].delayed_recall_check_6,
              delayed_recall_check_7:
                response.data.data[0].delayed_recall_check_7,
              delayed_recall_check_8:
                response.data.data[0].delayed_recall_check_8,
              delayed_recall_check_9:
                response.data.data[0].delayed_recall_check_9,
              delayed_recall_check_10:
                response.data.data[0].delayed_recall_check_10,
            },
            () =>
              this.setState({
                loading: false,
                isLoaded: true,
              })
          );
        } else {
          this.setState({
            loading: false,
            isLoaded: true,
          });
        }
      })
      .catch((error) => {
        this.setState({ loading: false, isLoaded: true });
      });
  };

  enter = (event) => {
    var elem = document.getElementById("body");
    toggleFullscreen(elem);
  };

  render() {
    const totalOfAllValues =
      Number(this.state.written_picture_score) +
      Number(this.state.spelling_score) +
      Number(this.state.language_comprehension_score) +
      Number(this.state.reverse_digit_span_score) +
      Number(this.state.executive_alternation_score) +
      Number(this.state.sentence_completion_score) +
      Number(this.state.social_congnition_score) +
      Number(this.state.fluency_ls_score) +
      Number(this.state.fluency_lt_score) +
      Number(this.state.dot_countring_score) +
      Number(this.state.cube_countring_score) +
      Number(this.state.number_location_score) +
      Number(this.state.recall_score) +
      Number(this.state.delayed_recall_score) +
      Number(this.state.delayed_congniation_total_score);

    return (
      <div className="view-ecas-form">
        <Header />
        <div className="row" id="top-section">
          <Sidebar />
          <div
            className="col-lg-10 main-section add-user top-space"
            style={{ marginLeft: "auto", paddingTop: 0 }}
          >
            <Spin spinning={this.state.loading}>
              <br />
              <a
                href="#top-section"
                style={{ color: "#fff" }}
                id="back-to-top-button"
                className="back-to-top-button"
              >
                <i className="fas fa-chevron-up"></i>
              </a>

              <div
                className="wrapper clearfix"
                style={{
                  paddingTop: 0,
                  transform: "scale(0.98)",
                  marginTop: -60,
                }}
              >
                <div
                  className="multisteps-form ecas-form"
                  style={{ marginTop: -255 }}
                >
                  {/* End Top buttons  */}
                  <div className="row">
                    <div className="col-12 col-lg-11 m-auto">
                      <div className="wizard-content-form">
                        <div
                          className="wizard-form-field"
                          style={{
                            margin: 0,
                            maxWidth: "100%",
                          }}
                        >
                          <Spin spinning={this.state.loading} delay={500}>
                            <div className="container">
                              <div className="row border border-dark grey ">
                                <div className="col-lg-12">
                                  <div className="text-align-center py-4 font-weight-bold fs-19">
                                    EDINBURGH COGNITIVE AND BEHAVIOURAL ALS
                                    SCREEN – ECAS <br />
                                    English Version (2013)
                                  </div>
                                </div>
                              </div>
                              <div className="row border border-dark grey">
                                <div className="col-lg-12">
                                  <div
                                    className="py-2"
                                    style={{
                                      fontSize: 16,
                                      maxEidth: 900,
                                      margin: "0 auto",
                                      textAlign: "justify",
                                    }}
                                  >
                                    The ECAS is a practical screening tool that
                                    incorporates a range of short cognitive
                                    tests that have been shown to be sensitive
                                    to cognitive impairment in ALS. The ECAS has
                                    been designed to differentiate between the
                                    different profiles common with ageing
                                    including depression, Alzheimer’s disease
                                    and Frontotemporal Dementia. Executive
                                    Functions, Memory, Language, Visuospatial
                                    skills and Social cognition are specifically
                                    assessed whilst a Behavioural and Psychosis
                                    brief interview can be carried out with
                                    carers or relatives. The ECAS is designed
                                    for ALS patients and answers can be given
                                    verbally. It is suitable for patients who
                                    are anarthric or patients who have no hand
                                    motor function.
                                  </div>
                                </div>
                              </div>
                              {localStorage.getItem("PHIStatus") != "true" && (
                                <div className="row p-3 border border-dark">
                                  <div className="col-lg-6">
                                    <span className="fs-19">
                                      Date Of Testing:{" "}
                                      {this.state.submitted_date}
                                    </span>
                                  </div>
                                  <div className="col-lg-6">
                                    <span className="fs-19">
                                      Neurostamp Id: {this.state.neurostamp_id}
                                    </span>
                                  </div>
                                </div>
                              )}
                              <SectionHeader
                                heading={"#1 Language - Naming"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <LanguageNamingSection
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#2 LANGUAGE - Comprehension"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <LanguageComprehension
                                  data={this.state.responseData}
                                />
                              )}
                              <div className="row border border-dark">
                                <div className="col-lg-10">
                                  <SectionHeader
                                    heading={"#3 MEMORY - Immediate recall"}
                                    textAlignClass={"text-left"}
                                  />
                                  {this.state.isLoaded == true && (
                                    <ImmediateRecall
                                      data={this.state.responseData}
                                    />
                                  )}
                                  <br />
                                  <br />
                                </div>
                                <div
                                  className="col-lg-2 pt-2"
                                  style={{ borderLeft: "1px solid #000" }}
                                >
                                  <span className="fs-19">Score (0 - 10) </span>
                                  <input
                                    type="number"
                                    disabled
                                    name="recall_score"
                                    value={this.state.recall_score}
                                    className="ecas-input-field"
                                    placeholder="Score"
                                  />
                                  <br />
                                  <p className="fs-19">
                                    Also use this score to calculate % retention
                                    later
                                  </p>
                                </div>
                              </div>
                              <SectionHeader
                                heading={"#4 LANGUAGE - Spelling"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <LanguageSpellingSection
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#5 FLUENCY - Letter S"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <FluencyLetterS
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#6 EXECUTIVE - Reverse Digit Span"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <ReverseDigitSpan
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#7 EXECUTIVE - Alternation"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <AlternationSection
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#8 FLUENCY - Letter T"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <FluencyLetterT
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#9 VISUOSPATIAL - Dot Counting"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <DotCountingSection
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#9 VISUOSPATIAL - Cube Counting"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <CubeCountingSection
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#10 VISUOSPATIAL - Number Location"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <NumberLocation
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#11 EXECUTIVE - Sentence Completion"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <SentenceCompletion
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#12 SOCIAL COGNITION - Part A"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <SocialCongPartA
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#12 SOCIAL COGNITION - Part B"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <SocialCongPartB
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#13 MEMORY - Delayed Recall"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <MemoryDelayedRecall
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"#14 MEMORY - Delayed Recognition"}
                                textAlignClass={"text-left"}
                              />
                              {this.state.isLoaded == true && (
                                <MemoryDelayedRec
                                  data={this.state.responseData}
                                />
                              )}
                              <SectionHeader
                                heading={"SCORES"}
                                textAlignClass={"text-left"}
                              />
                              <div className="row border border-dark">
                                <div className="col-lg-12 px-0">
                                  <table className="fs-19 table-black w-100 border border-dark text-right">
                                    <tbody>
                                      <tr>
                                        <td>Language &nbsp;</td>
                                        <td
                                          style={{
                                            padding: "9px 16px 10px 8px",
                                          }}
                                        >
                                          Naming ={" "}
                                          {this.state.written_picture_score}/8
                                          <br />
                                          Comprehension ={" "}
                                          {
                                            this.state
                                              .language_comprehension_score
                                          }
                                          /8 <br />
                                          Spelling = {this.state.spelling_score}
                                          /12
                                        </td>
                                        <td>
                                          {Number(
                                            this.state.written_picture_score
                                          ) +
                                            Number(
                                              this.state
                                                .language_comprehension_score
                                            ) +
                                            Number(this.state.spelling_score)}
                                          /28 &nbsp;
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Verbal Fluency &nbsp;</td>
                                        <td
                                          style={{
                                            padding: "9px 16px 10px 8px",
                                          }}
                                        >
                                          Fluency Letter S ={" "}
                                          {this.state.fluency_ls_score}/12
                                          <br />
                                          Fluency Letter T ={" "}
                                          {this.state.fluency_lt_score}/12
                                        </td>
                                        <td>
                                          {Number(this.state.fluency_ls_score) +
                                            Number(this.state.fluency_lt_score)}
                                          /24 &nbsp;
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Executive &nbsp;</td>
                                        <td
                                          style={{
                                            padding: "9px 16px 10px 8px",
                                          }}
                                        >
                                          Reverse Digit Span ={" "}
                                          {this.state.reverse_digit_span_score}
                                          /12
                                          <br />
                                          Alternation ={" "}
                                          {
                                            this.state
                                              .executive_alternation_score
                                          }
                                          /12
                                          <br />
                                          Sentence Completion ={" "}
                                          {this.state.sentence_completion_score}
                                          /12
                                          <br />
                                          Social Cognition ={" "}
                                          {this.state.social_congnition_score}
                                          /12
                                        </td>
                                        <td>
                                          {Number(
                                            this.state.reverse_digit_span_score
                                          ) +
                                            Number(
                                              this.state
                                                .executive_alternation_score
                                            ) +
                                            Number(
                                              this.state
                                                .sentence_completion_score
                                            ) +
                                            Number(
                                              this.state.social_congnition_score
                                            )}
                                          /48 &nbsp;
                                        </td>
                                      </tr>
                                      <tr className="light-grey">
                                        <td colSpan="2">
                                          <b>ALS-SPECIFIC:</b> &nbsp;
                                        </td>
                                        <td>
                                          <b>
                                            {Number(
                                              this.state
                                                .reverse_digit_span_score
                                            ) +
                                              Number(
                                                this.state
                                                  .executive_alternation_score
                                              ) +
                                              Number(
                                                this.state
                                                  .sentence_completion_score
                                              ) +
                                              Number(
                                                this.state
                                                  .social_congnition_score
                                              ) +
                                              Number(
                                                this.state.fluency_ls_score
                                              ) +
                                              Number(
                                                this.state.fluency_lt_score
                                              ) +
                                              Number(
                                                this.state.written_picture_score
                                              ) +
                                              Number(
                                                this.state
                                                  .language_comprehension_score
                                              ) +
                                              Number(this.state.spelling_score)}
                                            /100
                                          </b>{" "}
                                          &nbsp;
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          style={{ height: 20 }}
                                          colSpan="3"
                                        ></td>
                                      </tr>
                                      <tr>
                                        <td>Memory &nbsp;</td>
                                        <td
                                          style={{
                                            padding: "9px 16px 10px 8px",
                                          }}
                                        >
                                          Immediate recall ={" "}
                                          {this.state.recall_score}/10
                                          <br />
                                          Delayed recall ={" "}
                                          {this.state.delayed_recall_score}/10
                                          <br />
                                          Delayed recognition ={" "}
                                          {
                                            this.state
                                              .delayed_congniation_total_score
                                          }
                                          /4
                                        </td>
                                        <td>
                                          {Number(this.state.recall_score) +
                                            Number(
                                              this.state.delayed_recall_score
                                            ) +
                                            Number(
                                              this.state
                                                .delayed_congniation_total_score
                                            )}
                                          /24 &nbsp;
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Visuospatial &nbsp;</td>
                                        <td
                                          style={{
                                            padding: "9px 16px 10px 8px",
                                          }}
                                        >
                                          Dot Counting ={" "}
                                          {this.state.dot_countring_score}/4
                                          <br />
                                          Cube Counting ={" "}
                                          {this.state.cube_countring_score}/4
                                          <br />
                                          Number Location T ={" "}
                                          {this.state.number_location_score}/4
                                        </td>
                                        <td>
                                          {Number(
                                            this.state.dot_countring_score
                                          ) +
                                            Number(
                                              this.state.cube_countring_score
                                            ) +
                                            Number(
                                              this.state.number_location_score
                                            )}
                                          /12 &nbsp;
                                        </td>
                                      </tr>
                                      <tr className="light-grey">
                                        <td colSpan="2">
                                          <b>ALS NON-SPECIFIC:</b> &nbsp;
                                        </td>
                                        <td>
                                          <b>
                                            {Number(
                                              this.state.dot_countring_score
                                            ) +
                                              Number(
                                                this.state.cube_countring_score
                                              ) +
                                              Number(
                                                this.state.number_location_score
                                              ) +
                                              Number(this.state.recall_score) +
                                              Number(
                                                this.state.delayed_recall_score
                                              ) +
                                              Number(
                                                this.state
                                                  .delayed_congniation_total_score
                                              )}
                                            /36 &nbsp;
                                          </b>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td
                                          style={{ height: 20 }}
                                          colSpan="3"
                                        ></td>
                                      </tr>
                                      <tr className="light-grey">
                                        <td colSpan="2">
                                          <b>ECAS TOTAL SCORE:</b> &nbsp;
                                        </td>
                                        <td>
                                          <b>{totalOfAllValues}/136</b> &nbsp;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div className="row border border-dark border-top-0 grey">
                                <div className="col-lg-12">
                                  <div className="pt-3 font-weight-bold fs-19">
                                    <div className="row">
                                      <div className="col-lg-7">
                                        <span
                                          style={{
                                            position: "relative",
                                            top: 4,
                                          }}
                                        >
                                          Does the participant have caregiver?
                                        </span>
                                      </div>
                                      <div className="col-lg-5">
                                        <input
                                          type="radio"
                                          style={{
                                            height: 27,
                                            width: 20,
                                            position: "relative",
                                            top: 8,
                                          }}
                                          name="caregiver"
                                          value="1"
                                          checked={
                                            this.state.caregiver == "1"
                                              ? true
                                              : false
                                          }
                                        />
                                        &nbsp;&nbsp;Yes&nbsp;&nbsp;&nbsp;
                                        <input
                                          type="radio"
                                          style={{
                                            height: 27,
                                            width: 20,
                                            position: "relative",
                                            top: 8,
                                          }}
                                          name="caregiver"
                                          value="0"
                                          checked={
                                            this.state.caregiver == "0"
                                              ? true
                                              : false
                                          }
                                        />
                                        &nbsp;&nbsp;No
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="row border border-dark grey">
                                <div className="col-lg-12">
                                  <div className="text-align-center py-4 font-weight-bold fs-19">
                                    EDINBURGH COGNITIVE AND BEHAVIORAL ALS
                                    SCREEN – UNIVERSITY OF PENNSYLVANIA <br />
                                    (ECAS-PENN)
                                    <br />
                                    American English Form A, Version 1 (2018)
                                  </div>
                                </div>
                              </div>

                              <div className="row border border-dark">
                                <div className="col-lg-12 px-0">
                                  <div
                                    style={{
                                      width: "94%",
                                      margin: "20px auto 20px auto",
                                    }}
                                  >
                                    <SectionHeader
                                      heading={
                                        "BEHAVIOR SCREEN – Caregiver Interview"
                                      }
                                      textAlignClass={"text-align-center"}
                                    />
                                    {this.state.isLoaded == true && (
                                      <BehaviorSection
                                        data={this.state.responseData}
                                      />
                                    )}
                                    <div className="row border border-dark">
                                      <div className="col-lg-12 px-0">
                                        <SectionHeader
                                          heading={"ALS Psychosis Screen"}
                                          textAlignClass={
                                            "text-align-center w-100"
                                          }
                                          rowStyle={{
                                            maxWidth: "100%",
                                            margin: "0 auto",
                                          }}
                                        />
                                        {this.state.isLoaded == true && (
                                          <AlsPsychosisSection
                                            data={this.state.responseData}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                  <br />
                                </div>
                              </div>
                            </div>
                          </Spin>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Spin>
          </div>
        </div>
      </div>
    );
  }
}

export default View;
